module.exports = __webpack_public_path__ + "static/img/antea.54f4c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/antea.png
// module id = gx1m
// module chunks = 0